import PropTypes from 'prop-types';
import { config } from 'config';
import moment from 'moment';
import { theme } from 'styled';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
    ListItem,
    ListLayout
} from 'views/components';
import React, {
    Fragment,
    useEffect
} from 'react';
const { urlProfessional } = config;
const {
    successColor,
    textColor
} = theme;

const VideoconferenceList = ({
    getVideoconferenceList,
    history: { push },
    list,
    setVideoconferenceVideoconference,
    status
}) => {

    const { t } = useTranslation();

    useEffect(() => {
        getVideoconferenceList();
    }, [getVideoconferenceList]);
    
    const handleAddClick = () => {
        setVideoconferenceVideoconference({});
        push(t('/videoconferencia/crear'));
    };

    const handleEditClick = id => {
        push(`${ t('/videoconferencia/editar') }/${ id }`);
    };

    const handleLinkClick = ({ roomLink, share_code, status }) => {
        if (['oncourse', 'paused'].includes(status)) {
            window.open(`https://${ roomLink }`, share_code);
        }
    };

    const handleViewClick = id => {
        push(`${ t('/videoconferencia/ver') }/${ id }`);
    };

    return (
        <Fragment>
            <ListLayout
                buttonText={ t('Crear videoconferencia') }
                empty={ list.length === 0 }
                emptyMessage={ t('No tienes videoconferencias asignadas') }
                loading={ status === 'loading' }
                loadingMessage={ `${ t('Cargando videoconferencias') }...` }
                onButtonClick={ handleAddClick }
            >
                {
                    list.map(({
                        estimated_duration,
                        comment,
                        id,
                        speaker: { first_name, last_name },
                        share_code,
                        start_date_time,
                        status
                    }) => {
                        const doctorName = `${ last_name }, ${ first_name }`;
                        const linkText = ['oncourse', 'paused'].includes(status) ? t('Ir a la videoconferencia') : '';
                        const finalized = status === 'finalized';
                        const roomLink = `https://${ urlProfessional }${ t('/videoconferencia/sala') }/${ share_code }`;
                        return <ListItem
                            actions={ finalized ? ['VIEW'] : ['EDIT', 'VIEW'] }
                            height="100px"
                            key={ id }
                            link={ moment(start_date_time).isSameOrBefore(moment(), 'day') && !finalized ? linkText : '' }
                            subtitle={ comment }
                            text={ !finalized ? `${ t('Link de ingreso') }: ${ roomLink }` : '' }
                            title={
                                `
                                ${ `${ doctorName } - ` }
                                ${ moment(start_date_time).format('DD/MM/YYYY HH:mm') }
                                ${ estimated_duration ? ` - ${ estimated_duration } mins` : '' }
                                `
                            }
                            titleColor={ finalized ? successColor : textColor }
                            onEdit={ () => handleEditClick(id) }
                            onLinkClick={ () => handleLinkClick({ roomLink, share_code, status }) }
                            onView={ () => handleViewClick(id) }
                        />;
                    })
                }
            </ListLayout>
        </Fragment>
    );
};

VideoconferenceList.propTypes = {
    getVideoconferenceList: PropTypes.func,
    history: PropTypes.object,
    list: PropTypes.array,
    setVideoconferenceVideoconference: PropTypes.func,
    status: PropTypes.string
};

export default withRouter(VideoconferenceList);
